export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_RECEIVE = "DELETE_USER_RECEIVE";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";
export const RESET_DELETE_USER = "RESET_DELETE_USER";
